
import { defineComponent, ref, inject, watch } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

interface TeamMember {
  name: string;
  profilePicture: string;
  linkedInProfileUrl: string;
  jobTitle: string;
  introduction: string;
}

export default defineComponent({
  name: "PersonalDetails",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
    touchedParent: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const touched = ref<boolean>(false);
    const teamMembers = ref<Array<TeamMember>>([]);
    const formData = ref<Record<string,unknown>>(props.formDataTemp);
    const business = inject("business");
    const isAnyTeamMemberAdded = ref<boolean>(false);
    watch(
      () => props.touchedParent,
      (value) => {
        touched.value = value;
        if (value && !teamMembers.value?.length)
          isAnyTeamMemberAdded.value = true;
      }
    );
    watch(() => props.formDataTemp, (value) => {
      formData.value = {...value}

        teamMembers.value = value.teamMembers as Array<TeamMember>;

      emit("teamMembersLength", teamMembers.value.length);
    });
    const addTeamMember = () => {
      teamMembers.value.unshift({
        name: "",
        profilePicture: "",
        linkedInProfileUrl: "",
        jobTitle: "",
        introduction: "",
      });
      touched.value = false;
      isAnyTeamMemberAdded.value = false;
      emit("resetTouch", false);
      emit("teamMembersLength", teamMembers.value.length);
      fieldChanged();
    };
    const removeTeamMember = (index) => {
      teamMembers.value.splice(index, 1);
      touched.value = false;
      emit("teamMembersLength", teamMembers.value.length);
      fieldChanged();
      emit("resetTouch", false);
    };
    const fileAdded = async (index, event) => {
      try {
        const formDataFile = new FormData();
        formDataFile.append("file", event.target.files[0]);
        const response = await store.dispatch(
          Actions.UPLOAD_FILE,
          formDataFile
        );
        if (!response.includes("https://")) throw new Error();
        teamMembers.value[index].profilePicture = response;
        fieldChanged();
      } catch (err) {
        //}
      }
    };
    const fieldChanged = () => {
        formData.value["teamMembers"] = teamMembers.value
      emit("form-data", formData.value);
    };
    return {
      isAnyTeamMemberAdded,
      fileAdded,
      teamMembers,
      formData,
      fieldChanged,
      addTeamMember,
      removeTeamMember,
      touched,
    };
  },
});
